module.exports = __webpack_public_path__ + "img/structure.5affaf4c.png";